import { useAtomValue } from "jotai";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PageTemplate } from "@/components/PageTemplate";
import { OrderItemStatusEnum, RoleEnum } from "@/config/apiClient.types.ts";
import { useOrderItems, useRedirection } from "@/hooks";
import { useIsOMS } from "@/hooks/useIsOMS";
import { userAtom } from "@/store";
import { OrderItemDetails } from "./OrderItemDetails";
import { OrderItemDraft } from "./OrderItemDraft";

export const OrderItemPage = () => {
  const {
    id: clientOrderItemId = "",
    orderItemId: omsOrderItemId = "",
    orderId = "",
  } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const userAtomValue = useAtomValue(userAtom);

  const orderItemId = omsOrderItemId || clientOrderItemId;

  const isOMS = useIsOMS();
  const { useGetOrderItem } = useOrderItems();
  const getOrderItemDetailsQueryResult = useGetOrderItem({
    orderId,
    orderItemId,
  });

  const isLoading = getOrderItemDetailsQueryResult.isLoading;

  useRedirection({
    queryKeysToInvalidate: ["orderItem"],
    queryResult: getOrderItemDetailsQueryResult,
  });

  const orderItem = getOrderItemDetailsQueryResult.data?.data?.orderItem;
  const order = getOrderItemDetailsQueryResult.data?.data?.orderItem?.order;

  if (
    userAtomValue?.role !== RoleEnum.CSM &&
    location.pathname.includes("/oms")
  ) {
    void navigate("/404");
  }

  if (getOrderItemDetailsQueryResult?.isError || !orderItem || !order) {
    return null;
  }

  return (
    <PageTemplate>
      {!isOMS && orderItem?.status === OrderItemStatusEnum.DRAFT ? (
        <OrderItemDraft
          orderItem={orderItem}
          order={order}
          isLoading={isLoading}
        />
      ) : (
        <OrderItemDetails
          orderItem={orderItem}
          order={order}
          isLoading={isLoading}
          handleRefetchOrderItemDetails={() =>
            void getOrderItemDetailsQueryResult.refetch()
          }
        />
      )}
    </PageTemplate>
  );
};
